module.exports = __webpack_public_path__ + "img/capitecpay.3d347511.png";